import React from 'react';
import PropTypes from 'prop-types';
import { ListSubheader } from '@material-ui/core';

import {
  RESOURCE_CHANNELS,
  getResourceDocumentLabel,
  WEBSITE_CHANNELS,
  EMAIL_CSV_RESOURCE_DOCUMENTS,
} from 'src/data/performance';
import { FieldSelect } from 'src/components/FieldSelect';
import { FieldSelectMenuItem } from 'src/components/FieldSelectMenuItem';
import { ChannelItem } from 'src/components/ChannelItem';
import { useStyles } from './useStyles';

export const ResourceSelect = ({
  className,
  value,
  onChange,
  onCsvItemClick,
  csvUploadMode,
  disabled,
  websitesOnly,
  csvFile,
}) => {
  const styles = useStyles();
  const resources = websitesOnly ? WEBSITE_CHANNELS : RESOURCE_CHANNELS;

  return (
    <>
      <FieldSelect
        className={className}
        label="Select type"
        value={value}
        onChange={onChange}
        disabled={disabled}
        renderValue={(selectedValue) => (
          <ChannelItem
            channel={selectedValue}
            classes={{ icon: styles.icon }}
          />
        )}
        headerClasses={{ root: 'mb-0', label: styles.label }}
      >
        {!websitesOnly && <ListSubheader className={styles.subheader}>Email reports</ListSubheader>}
        {!websitesOnly &&
          EMAIL_CSV_RESOURCE_DOCUMENTS.map((csvResource) => (
            <FieldSelectMenuItem
              key={csvResource}
              value={csvResource}
              onClick={() => (csvFile ? null : onCsvItemClick())}
              classes={{ selected: styles.csvSelected }}
            >
              <ChannelItem
                channel={csvResource}
                classes={{ icon: styles.icon }}
                accountLabel={`${getResourceDocumentLabel(csvResource)} (CSV)`}
              />
            </FieldSelectMenuItem>
          ))}
        {!csvUploadMode && <ListSubheader className={styles.subheader}>Web pages</ListSubheader>}
        {!csvUploadMode &&
          resources.map((channel) => {
            return (
              <FieldSelectMenuItem
                key={channel}
                value={channel}
              >
                <ChannelItem
                  channel={channel}
                  classes={{ icon: styles.icon }}
                />
              </FieldSelectMenuItem>
            );
          })}
      </FieldSelect>
    </>
  );
};

ResourceSelect.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onCsvItemClick: PropTypes.func.isRequired,
  websitesOnly: PropTypes.bool,
  csvFile: PropTypes.bool,
};

ResourceSelect.defaultProps = {
  className: '',
  value: undefined,
  websitesOnly: false,
  csvFile: false,
};
